import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export interface Department {
  id: string;
  name: string;
  parentId: string | null;
  createdAt: string;
}

export function useDepartments() {
  return useQuery({
    queryKey: ['departments'],
    queryFn: async () => {
      const r = await api.get<{ departments: Department[] }>('/api/departments');
      return r.data.departments;
    },
    staleTime: 60_000,
  });
}

export function useCreateDepartment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { name: string; parentId?: string }) => {
      const r = await api.post<Department>('/api/departments', input);
      return r.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['departments'] }),
  });
}

export function useUpdateDepartment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, name, parentId }: { id: string; name?: string; parentId?: string | null }) => {
      const r = await api.patch<Department>(`/api/departments/${id}`, { name, parentId });
      return r.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['departments'] }),
  });
}

export function useDeleteDepartment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const r = await api.delete<{ ok: boolean }>(`/api/departments/${id}`);
      return r.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['departments'] }),
  });
}
